"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataFetched = exports.formatRemoteUrl = void 0;
const qs_1 = __importDefault(require("qs"));
// Checks does query parameters from window URL contains nikeEnv_ param
const getEnvRouteParam = (mfeName) => {
    if (typeof window === `undefined` || !mfeName)
        return ``;
    const urlLocation = window.location;
    const searchParams = new URLSearchParams(urlLocation.search);
    const nikeEnvParam = searchParams.get(`nikeEnv_${mfeName}`);
    return nikeEnvParam ? `nikeEnv=${nikeEnvParam}&` : ``;
};
const formatRemoteUrl = (endpoint, endpointQuery) => {
    const url = new URL(endpoint);
    const endpointQueryParams = url.search.substring(1);
    const endpointWithoutQuery = `${url.origin}${url.pathname}`;
    const requestQueryParams = qs_1.default.stringify(endpointQuery) ? `${qs_1.default.stringify(endpointQuery)}&` : ``;
    const mfeName = url.pathname.replace(`/fragments/`, ``);
    const envRouteParam = getEnvRouteParam(mfeName);
    if (!endpointQueryParams) {
        return `${endpoint}?${envRouteParam}${requestQueryParams}json=true`;
    }
    return `${endpointWithoutQuery}?${envRouteParam}${requestQueryParams}${endpointQueryParams}&json=true`;
};
exports.formatRemoteUrl = formatRemoteUrl;
const isDataFetched = (data) => {
    if (data.component === `` || data.moduleUrl === ``) {
        return false;
    }
    return true;
};
exports.isDataFetched = isDataFetched;
//# sourceMappingURL=utils.js.map